import React from "react";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

const ProfileLinksMain = styled("div")(({ theme }) => ({
  "& li": {
    listStyle: "none",
    display: "flex",
    position: "relative",
    alignItems: "center",
    "&.active": {
      background: "#E2E2E2",
      "&::before": {
        content: "''",
        position: "absolute",
        background: "#0B0B0B",
        top: 0,
        left: 0,
        width: "5px",
        height: "100%",
      },
      "& button": {
        "&:hover": {
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
        },
      },
    },
    "&.Logout": { cursor: "pointer" },
  },
}));
const ButtonMain = styled(Button)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "20px",
  lineHeight: "16px",
  color: "#000000",
  fontFamily: theme.typography.fontFamily,
  textDecoration: "none",
  padding: "16px",
  display: "block",
  width: "100%",
  height: "100%",
  paddingLeft: "30px",
  textTransform: "capitalize",
  textAlign: "left",
  "&:hover": { color: "rgb(0, 0, 0)", backgroundColor: "rgb(246, 246, 246)" },
}));

const SideLinks = ({ links, selectedLink, onLinkClick }) => {
  return (
    <>
      <ProfileLinksMain>
        <ul>
          {links &&
            links?.map((link, index) => (
              <li
                key={link.label}
                className={selectedLink === index ? "active" : ""}
              >
                <ButtonMain onClick={() => onLinkClick(index)}>
                  {link.label}
                </ButtonMain>
              </li>
            ))}
        </ul>
      </ProfileLinksMain>
    </>
  );
};

export default SideLinks;
